import Swiper from "swiper";

const swiper = new Swiper(".home-slider-container", {
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
        425: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        }
    }
});
